import AccountModel from 'cio/models/account';
import { getAppApiHostForDataCenter } from 'cio/utils/data-centers';

export function webhookUrl(webhookId: string | null, account: AccountModel | null) {
  if (webhookId == null) {
    return '';
  }

  let baseUrl = account?.dataCenter != null ? getAppApiHostForDataCenter(account?.dataCenter) : '';
  return `${baseUrl ?? ''}/v1/webhook/${webhookId}`;
}
